"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.HistoryItemDropdown = HistoryItemDropdown;
const jsx_runtime_1 = require("react/jsx-runtime");
const React = __importStar(require("react"));
const antd_1 = require("antd");
const styled_components_1 = __importDefault(require("styled-components"));
const icons_1 = require("@ant-design/icons");
const react_intl_1 = require("react-intl");
const ApplicationDetailModal_style_1 = require("./HiringProcessColumns/ApplicationDetailModal/ApplicationDetailModal.style");
const IconWrapper = styled_components_1.default.div `
	padding-right: 0.25rem;
	display: inline-flex;
	align-items: center;
`;
function HistoryItemDropdown({ historyItem, onDeleteButtonClick, setSelectedHistoryItemId, setEditHistoryItemText, setEditingHistoryItem, }) {
    const menuButtons = [
        {
            key: 'edit',
            disabled: !historyItem.is_owner,
            onClick: () => {
                setEditingHistoryItem(true);
                setEditHistoryItemText(historyItem.message);
                setSelectedHistoryItemId(historyItem.id);
            },
            icon: (0, jsx_runtime_1.jsx)(icons_1.EditOutlined, {}),
        },
        {
            key: 'delete',
            disabled: !historyItem.is_owner,
            onClick: () => onDeleteButtonClick(historyItem.id),
            icon: (0, jsx_runtime_1.jsx)(icons_1.DeleteOutlined, {}),
        },
    ];
    return ((0, jsx_runtime_1.jsx)(antd_1.Dropdown, { className: "m-l-s", overlayStyle: { zIndex: 3000000001 }, overlay: (0, jsx_runtime_1.jsx)(antd_1.Menu, { className: "flex-col", children: menuButtons.map(menuButton => ((0, jsx_runtime_1.jsxs)(antd_1.Menu.Item, { disabled: menuButton.disabled, onClick: menuButton.onClick, children: [(0, jsx_runtime_1.jsx)(IconWrapper, { children: menuButton.icon }), (0, jsx_runtime_1.jsx)(react_intl_1.FormattedMessage, { id: `admin.hiring_process.detail_modal.${menuButton.key}` })] }, menuButton.key))) }), trigger: ['click'], children: (0, jsx_runtime_1.jsx)(ApplicationDetailModal_style_1.DropdownButtonWrapper, { type: "text", size: "small", children: (0, jsx_runtime_1.jsx)(icons_1.EllipsisOutlined, { className: "font-size-l" }) }) }));
}
